'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { MICRO_TRANSITION_TIMING } from 'HubStyleTokens/times';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import unescapedText from 'I18n/utils/unescapedText';
import UILink from 'UIComponents/link/UILink';
import ProfileCard from 'ecosystem-marketplace-core/components/cards/ProfileCard';
import ProfileListing from 'ecosystem-marketplace-core/records/ProfileListing';
import { getIsPrerenderUserAgent } from 'ecosystem-marketplace-core/utils/userAgent';
import { getCanonicalAppContext } from '../../selectors/app';
import { getFullLocationUrl } from '../../utils/urls';
const StyledLink = styled(props => {
  const {
    Link
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["Link"]);

  return /*#__PURE__*/_jsx(Link, Object.assign({}, rest));
}).withConfig({
  displayName: "ResultCard__StyledLink",
  componentId: "cu07na-0"
})(["display:flex;align-items:stretch;height:100%;"]);
const StyledProfileCard = styled(ProfileCard).withConfig({
  displayName: "ResultCard__StyledProfileCard",
  componentId: "cu07na-1"
})(["&&{border:2px solid transparent;transition:border ", " ease-out;&:hover{border-color:", ";}}"], MICRO_TRANSITION_TIMING, CALYPSO_MEDIUM);

const ResultCard = ({
  onClick,
  result
}) => {
  const canonicalAppContext = useSelector(getCanonicalAppContext);
  const isPrerender = getIsPrerenderUserAgent();
  const {
    description,
    logoUrl,
    name,
    partnerType,
    reviewSummary,
    slug,
    tier
  } = result;
  const linkProps = useMemo(() => {
    const pathname = `/${slug}`;

    if (isPrerender) {
      return {
        Link: UILink,
        href: getFullLocationUrl({
          pathname
        }, canonicalAppContext)
      };
    }

    return {
      Link: UIRouterLink,
      to: pathname
    };
  }, [canonicalAppContext, isPrerender, slug]);
  return /*#__PURE__*/_jsx(StyledLink, Object.assign({}, linkProps, {
    "aria-label": unescapedText('ecosystem-marketplace-solutions-ui.storefront.results.resultsCard.accessibleLabel', {
      name
    }),
    onClick: onClick,
    use: "unstyled",
    children: /*#__PURE__*/_jsx(StyledProfileCard, {
      className: "m-bottom-0",
      description: description,
      logoUrl: logoUrl,
      name: name,
      partnerType: partnerType,
      reviewSummary: reviewSummary,
      tier: tier
    })
  }));
};

ResultCard.propTypes = {
  onClick: PropTypes.func,
  result: PropTypes.instanceOf(ProfileListing).isRequired
};
export default ResultCard;